export const lightOrange = "#FBC3AA"
export const lightCyan = "#A8E1DE"
export const lightYellow = "#FDEE99"
export const lightBlue = "#B2E6F9"
